import React from 'react';
import {
  DataGrid,
  GridRowId,
  GridSelectionModelChangeParams,
  GridSortModel,
  GridSortModelParams,
} from "@material-ui/data-grid";
import { RELEASE_LIST_COLUMNS } from "./columns";
import { SEARCH_PAGE_SIZE } from "../../../sdk/search";
import { ReleaseIndexSchema } from '../../../../../../services/search-admin/types/index-schema/release-index-schema';

interface ReleaseGridProps {
  releases: ReleaseIndexSchema[];
  size: number;
  loading: boolean;
  hasCheckbox?: boolean;
  page?: number;
  selection?: GridRowId[];
  sortModel?: GridSortModel;
  handleClick: (value: ReleaseIndexSchema, ev: React.MouseEvent<Element, MouseEvent>) => void;
  handlePageChange?: (page: number) => void;
  handleSortModelChange?: (model: GridSortModelParams) => void;
  handleSelection?: (selection: GridSelectionModelChangeParams) => void;
};

export const ReleaseGrid: React.FC<ReleaseGridProps> = ({
  releases,
  size,
  page,
  loading,
  selection,
  sortModel,
  hasCheckbox,
  handleClick,
  handlePageChange,
  handleSortModelChange,
  handleSelection,
}) => {
  return (
    <DataGrid
      {...(page !== undefined ? {pagination: true} : {})}
      rows={releases}
      columns={RELEASE_LIST_COLUMNS}
      pageSize={SEARCH_PAGE_SIZE}
      rowCount={size}
      onPageChange={handlePageChange ? (params) => handlePageChange(params.page) : undefined}
      page={page}
      paginationMode="server"
      sortingMode="server"
      sortModel={sortModel}
      onSortModelChange={handleSortModelChange}
      loading={loading}
      checkboxSelection={hasCheckbox}
      selectionModel={selection}
      disableSelectionOnClick={!selection?.length}
      onRowClick={(params, ev) => handleClick(params.row as ReleaseIndexSchema, ev)}
      onSelectionModelChange={handleSelection ? (params) => handleSelection(params) : undefined}
    />
  )
}